import { render, staticRenderFns } from "./PalletLogList.vue?vue&type=template&id=f5157dc2&"
import script from "./PalletLogList.vue?vue&type=script&lang=js&"
export * from "./PalletLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5157dc2')) {
      api.createRecord('f5157dc2', component.options)
    } else {
      api.reload('f5157dc2', component.options)
    }
    module.hot.accept("./PalletLogList.vue?vue&type=template&id=f5157dc2&", function () {
      api.rerender('f5157dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/PalletLogList.vue"
export default component.exports